import { Confirmation, MailQueue } from '@/domain/Confirmation'
import axios from 'axios'
import { SendMail } from '@/domain/SendMail'

/**
 * 検索条件
 */
export class SerchConditon {
    /** 請書番号 */
    confirmationNo = ""
    /** 期間開始日 */
    startOn = ""
    /** 期間終了日 */
    endOn = ""
    /** 顧客都道府県コード */
    customerPrefectureCode = ""
    /** 顧客コード */
    customerCode = ""
    /** 顧客枝番 */
    customerBranchNumber = ""
    /** 顧客名 */
    customerName = ""
    /** 検査依頼種別 */
    requestType: number | null = null
    /** 検査依頼の備考 */
    requestNote = ""
    /* 有効 */
    isActive = true

    /* 画面用 */
    /** 期間タイプ */
    dateType = 3

    /**
     * コンストラクタ
     * @param init 
     */
    constructor(init?: Partial<SerchConditon>) {
        Object.assign(this, init)
    }
}

/**
 * 請書サービス
 */
export default class ConfirmationsService {
    /** インスタンス */
    private static _instance: ConfirmationsService

    /**
     * コンストラクタ
     */
    // eslint-disable-next-line
    private constructor() {}

    /**
     * インスタンスの取得
     */
    public static get instance() {
        if (!this._instance) {
            this._instance = new ConfirmationsService();
        }
        return this._instance;
    }

    /**
     * 新規作成
     */
    public async createNew(): Promise<Confirmation> {
        return await axios.get("/api/confirmation/new")
            .then((results) => {
                if (results.status === 200) {
                    return this.convert(results.data)
                } else {
                    throw results.statusText
                }
            })
            // eslint-disable-next-line
            .catch((error) => {
                throw error
            })
    }

    /**
     * 参照新規作成
     */
    public async referenceNew(requestNos: string[]): Promise<Confirmation> {
        const params = requestNos.map(x => `requestNos=${x}`).join("&")
        return await axios.get(`/api/confirmation/new?${params}`)
            .then((results) => {
                if (results.status === 200) {
                    return this.convert(results.data)
                } else {
                    throw results.statusText
                }
            })
            // eslint-disable-next-line
            .catch((error) => {
                throw error
            })
    }

    /**
     * 編集
     */
    public async edit(no: string): Promise<Confirmation> {
        return await axios.get(`/api/confirmation/edit/${no}`)
            .then((results) => {
                if (results.status === 200) {
                    return this.convert(results.data)
                } else {
                    throw results.statusText
                }
            })
            .catch((error) => {
                throw error
            })
    }

    /**
     * 新規保存
     */
    public async create(dto: Confirmation): Promise<Confirmation> {
        return await axios.post("/api/confirmation/new", dto)
            .then((results) => {
                if (results.status === 200) {
                    return this.convert(results.data)
                } else {
                    throw results.statusText
                }
            })
            .catch((error) => {
                throw error
            })
    }

    /**
     * 保存
     */
    public async update(dto: Confirmation): Promise<Confirmation> {
        return await axios.put(`/api/confirmation/edit/${dto.confirmationNo}`, dto)
            .then((results) => {
                if (results.status === 200) {
                    return this.convert(results.data)
                } else {
                    throw results.statusText
                }
            })
            .catch((error) => {
                throw error
            })
    }

    /**
     * 削除
     */
    public async delete(no: string): Promise<Confirmation> {
        return await axios.delete(`/api/confirmation/delete/${no}`)
            .then((results) => {
                if (results.status === 200) {
                    return this.convert(results.data)
                } else {
                    throw results.statusText
                }
            })
            .catch((error) => {
                throw error
            })
    }

    /**
     * 印刷
     */
    public async print(no: string): Promise<Confirmation> {
        return await axios.put(`/api/confirmation/print/${no}`)
            .then((results) => {
                if (results.status === 200) {
                    return this.convert(results.data)
                } else {
                    throw results.statusText
                }
            })
            .catch((error) => {
                throw error
            })
    }

    /**
     * 請書一覧を検索
     */
    public async findAll(serchConditon: SerchConditon): Promise<Confirmation[]> {
        return await axios.get("/api/confirmations", {params: serchConditon})
            .then((results) => {
                if (results.status === 200) {
                    return (results.data as Confirmation[]).map(x => this.convert(x))
                } else {
                    throw results.statusText
                }
            })
            .catch((error) => {
                throw error
            })
    }

    /**
     * メール送信テンプレートの取得
     */
    public async generateMailTemplate(nos: string[]): Promise<SendMail> {
        const params = nos.map(x => `no=${x}`).join("&")
        return await axios.get(`/api/confirmations/generate_mail_template?${params}`)
            .then((results) => {
                if (results.status === 200) {
                    const sendMail = results.data as SendMail
                    return new SendMail({ ...sendMail })
                } else {
                    throw results.statusText
                }
            })
            .catch((error) => {
                throw error
            })
    }

    /**
     * メール送信キューへの登録
     */
    public async mailQueuePush(mailQueue: MailQueue): Promise<MailQueue> {
        return await axios.post("/api/confirmations/mail_queue_push", mailQueue)
        .then((results) => {
            if (results.status === 200) {
                return results.data as MailQueue
            } else {
                throw results.statusText
            }
        })
        .catch((error) => {
            throw error
        })
    }

    /**
     * 受信データの変換
     * @param data
     */
    // eslint-disable-next-line
    private convert(data: any): Confirmation {
        const confirmation = data as Confirmation
        confirmation.deliveryOn = confirmation.deliveryOn || ""
        return new Confirmation({ ...confirmation })
    }
}
